<template>
  <div class="video-content">
    <h4 class="video-content__title">
      {{ marque }} -
      <span class="title__light">{{ nom }} {{ /*description*/ }}</span>
    </h4>
    <span class="video-content__thematic">{{ thematique }}</span>
    <span v-if="support" class="video-content__support">{{ support }}</span>
  </div>
</template>

<script>
export default {
  props: {
    nom: {
      type: String,
      default: ""
    },
    marque: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    thematique: {
      type: String,
      default: ""
    },
    support: {
      type: String,
      default: ""
    }
  }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
@import "@/styles/variables.scss";
.video-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  &__title {
    font-size: 0.9em;
    line-height: 1.7;
    color: $color-primary--dark;
    color: var(--color-primary--dark, $color-primary--dark);
    .title__light {
      font-weight: 500;
    }
  }

  &__thematic {
    color: $color-primary--light;
    color: var(--color-primary--light, $color-primary--light);
  }

  &__title,
  &__thematic {
    margin-bottom: 0.5em;
  }

  &__support {
    text-transform: uppercase;
    color: $color-accent;
    color: var(--color-accent, $color-accent);
    font-weight: 600;
  }
}
</style>
